export enum ChannelPlatform {
    WHATSAPP = 'WHATSAPP',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    SITE = 'SITE'
}

export const PLATFORM_PREFIX = {
    [ChannelPlatform.FACEBOOK]: 'FB',
    [ChannelPlatform.INSTAGRAM]: 'IG',
    [ChannelPlatform.WHATSAPP]: 'WP'
} as const

export const isFacebookPlatform = (channel = '') => channel.startsWith(PLATFORM_PREFIX.FACEBOOK)

export const isInstagramPlatform = (channel = '') => channel.startsWith(PLATFORM_PREFIX.INSTAGRAM)

export const isWhatsAppPlatform = (channel = '') => !isFacebookPlatform(channel) && !isInstagramPlatform(channel)

export const getChannelPlatform = (channel: string): ChannelPlatform => {
    if (isFacebookPlatform(channel)) {
        return ChannelPlatform.FACEBOOK
    }

    if (isInstagramPlatform(channel)) {
        return ChannelPlatform.INSTAGRAM
    }

    return ChannelPlatform.WHATSAPP
}
